/*@flow*/
import type { Element } from 'react';
import { createElement } from 'react';

type SectionT = { tag: string, props: {} };
type AnyRecord = { [key: string]: any };

export function SectionBefore(
  locals: { before?: SectionT } & AnyRecord
): null | Element<string> {
  const { before, hideWhen } = locals;
  if (!before) return null;
  if (hideWhen && hideWhen()) return null;

  if (typeof before === 'function') {
    return createElement(before, locals);
  } else if (typeof before === 'object') {
    const { tag, props } = before;
    return createElement(tag, props);
  }
  return null;
}

export function SectionAfter(
  locals: { after?: SectionT } & AnyRecord
): null | Element<string> {
  const { after, hideWhen } = locals;
  if (!after) return null;
  if (hideWhen && hideWhen()) return null;

  if (typeof after === 'function') {
    return createElement(after, locals);
  } else if (typeof after === 'object') {
    const { tag, props } = after;
    return createElement(tag, props);
  }
  return null;
}
